export default {
    data: () => ({
        translations: {
            addDiscount: {
                el: "Προσθήκη Εκπτωτικών Κουπονιών",
                en: "Add Discount Coupons",
                it: "Aggiungi Coupon di Sconto"
            },
            giftCategory: {
                el: "Κατηγορία Δώρου",
                en: "Gift Category",
                it: "Categoria di regalo"
            },
            product: {
                el: "Προϊόν",
                en: "Product",
                it: "Prodotto"
            },
            productPrice: {
                el: "Τιμή Προϊόντος",
                en: "Product Price",
                it: "Prezzo del prodotto"
            },
            discountType: {
                el: "Τύπος Έκπτωσης",
                en: "Discount Type",
                it: "Tipo di sconto"
            },
            amount: {
                el: "Ποσοστό",
                en: "Amount",
                it: "Valutare"
            }
        }
    })
};
